import { Folder } from '@mui/icons-material';
import React from 'react'
import { useNavigate } from 'react-router-dom'

const FolderComponent = ({user,users,_module,}) => {
    const navigate=useNavigate();
  return (
   <>
   <div
                 style={{
                   width: "100%",
                   minHeight: "20vh",
                   display: "flex",
                   flexWrap: "wrap",
                   gap: "5px",
                   padding: "5px",
                   marginTop: "10px",
                 }}
               >
                 <div
                   onClick={() =>
                     navigate(`/${_module}?folderId=${user._id}&name=${user.username}`)
                   }
                   className="h-[10vh] w-[15vw] cursor-pointer p-2 flex bg-white shadow-md rounded-lg hover:shadow-lg"
                 >
                   <div className="h-full w-[30%] flex justify-center items-center border-none border-black">
                     {" "}
                     <Folder
                       style={{ fontSize: "70px", color: "red" }}
                     // color="var(--primary-color)"
                     />
                   </div>
                   <div className="h-full w-[70%] p-2 flex flex-col justify-center items-start border-none border-black">
                     <p>{user?.username}</p>
                     {/* <p>{content.filter((c) => c.user._id == user._id)?.length}</p> */}
                   </div>
                 </div>
                 {users.map((user, index) => (
                   <>
                     <div
                       key={index}
                       onClick={() =>
                         navigate(
                           `/${_module}?folderId=${user._id}&name=${user.username}`
                         )
                       }
                       className="h-[10vh] w-[15vw] p-2 cursor-pointer flex bg-white shadow-md rounded-lg hover:shadow-lg"
                     >
                       <div className="h-full w-[30%] flex justify-center items-center border-none border-black">
                         {" "}
                         <Folder
                           style={{
                             fontSize: "70px",
                             color: "var(--primary-color)",
                           }}
                         // color="var(--primary-color)"
                         />
                       </div>
                       <div className="h-full w-[70%] p-2 flex flex-col justify-center items-start border-none border-black">
                         <p>{user?.username.substr(0, 10)}</p>
                         {/* <p>{user.contentCount}</p> */}
                       </div>
                     </div>
                   </>
                 ))}
               </div>
   </>
  )
}

export default FolderComponent